import { render, staticRenderFns } from "./Poetry.vue?vue&type=template&id=bf0c54f2"
import script from "./Poetry.vue?vue&type=script&lang=js"
export * from "./Poetry.vue?vue&type=script&lang=js"
import style0 from "./Poetry.vue?vue&type=style&index=0&id=bf0c54f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports